import {
  OrderInput,
  OrderOutput,
  OrdersQueryParams,
} from "../interfaces/orders";
import { BaseService } from "./BaseService";

export class OrderService extends BaseService<
  OrderInput,
  OrderOutput,
  OrdersQueryParams
> {
  constructor() {
    super();
    this.path = "orders";
  }
}
